export enum AbTestKeys {
	Edgeworkers = 'plp_usa_regions',
	HeaderRelase = 'gps_header_inspirational',
	pdp_shop_the_look = 'pdp_shop_the_look',
	PromoBanner = 'promo_countdown',
	shoppingcartFavoritesCrossSelling = 'shoppingcart_favorites_cross_selling',
	shoppingcartTransactionalProductCard = 'shoppingcart_transactional_product_card',
	ShowDiscount = 'show_discount_test_abc',
	ShowProductCarousel = 'shopping_cart_product_carousel_test_ab',
	Test = 'test',
}
